import noUiSlider from "nouislider";
import wNumb from "wnumb";
import "Common/paginator";
import { initTippy } from "Functions/tippy";
import { updateActivePropertyCheckboxes } from "./filter-sync";

let foundListingProductsLocale, listingProductsLocale;

const lang = document.querySelector("html").getAttribute("lang");
import(`Locale/${lang}.json`).then((module) => {
    foundListingProductsLocale = module.Catalog.Listing.FoundProducts;
    listingProductsLocale = module.Catalog.Listing.Products;
});

const $sort = $("#filter-sort"),
    $fakeSortButtons = $(".js-fake-sort-buttons"),
    $fakeSort = $("select#fake-sort"),
    $view = $("#filter-view"),
    $fakeView = $(".js-fake-view"),
    $bought = $("#filter-was-bought"),
    $fakeBought = $(".js-fake-bought");

let $rangeSlider;

// rEvent.on("Listing.fetchedData", function(data) {
//     var $titleElemHolder = $('.js-catalog-title'),
//         $titleElem = $titleElemHolder.find('h1'),
//         baseName = $titleElemHolder.attr('data-name'),
//         name = baseName;

//     if (data.entity && data.entity.heading) {
//         name = data.entity.heading;
//     } else if (data.filtered_parameters) {
//         name = baseName + " " + Object.values(data.filtered_parameters).join(" ");
//     }

//     if (!name) {
//         return;
//     }

//     $titleElem.html(name);

//     var title = document.title.split(" | ");

//     document.title = name + " | " + title[1];
// });

// Auto-check main optgroup when all its children are selected
function syncOptgroupCheckboxes($select) {
    const $container = $select.next().find("ul.multiselect-container");
    let changed = false;

    $container.find("li.multiselect-group").each(function () {
        const $groupLi = $(this);

        // Skip disabled optgroups
        if ($groupLi.hasClass("disabled")) return;

        // Find the is-level-0 item (main category option) right after the optgroup header
        const $level0Li = $groupLi.next(".is-level-0");
        if (!$level0Li.length) return;

        const level0Value = $level0Li.find('input[type="checkbox"]').val();
        if (!level0Value) return;

        // Find all DIRECT children (level-1) of this optgroup
        // Exclude: level-0, level-2+, and disabled items
        const $childLis = [];
        let $next = $level0Li.next();
        while ($next.length && !$next.hasClass("multiselect-group")) {
            // Skip disabled items, level-0, and level-2+ items (grandchildren)
            const isLevel0 = $next.hasClass("is-level-0");
            const isLevel2OrHigher = /is-level-[2-9]/.test($next.attr("class") || "");
            const isDisabled = $next.hasClass("disabled");

            if (!isDisabled && !isLevel0 && !isLevel2OrHigher) {
                $childLis.push($next);
            }
            $next = $next.next();
        }

        if ($childLis.length === 0) return;

        // Check if all direct children have 'active' class (meaning they are selected)
        const allChildrenActive = $childLis.every(($li) => $li.hasClass("active"));
        const level0Selected = $select.find(`option[value="${level0Value}"]`).prop("selected");

        if (allChildrenActive && !level0Selected) {
            $select.find(`option[value="${level0Value}"]`).prop("selected", true);
            changed = true;
        } else if (!allChildrenActive && level0Selected) {
            $select.find(`option[value="${level0Value}"]`).prop("selected", false);
            changed = true;
        }
    });

    if (changed) {
        // Refresh to sync UI with <select> state, then fix optgroup checkboxes
        $select.multiselect("refresh");

        // After refresh, manually sync the optgroup header checkboxes
        $container.find("li.multiselect-group").each(function () {
            const $groupLi = $(this);
            if ($groupLi.hasClass("disabled")) return;

            const $level0Li = $groupLi.next(".is-level-0");
            if (!$level0Li.length) return;

            const isLevel0Active = $level0Li.hasClass("active");
            const $groupCheckbox = $groupLi.find('input[type="checkbox"]');

            $groupCheckbox.prop("checked", isLevel0Active);
            $groupLi.toggleClass("active", isLevel0Active);
        });
    }
}

// Auto-check sub-group when all its children (level-2) are selected
function syncSubgroupCheckboxes($select) {
    const $container = $select.next().find("ul.multiselect-container");
    let changed = false;

    $container.find("li.multiselect-sub-group").each(function () {
        const $subGroupLi = $(this);
        if ($subGroupLi.hasClass("disabled")) return;

        const subGroupVal = $subGroupLi.find('input[type="checkbox"]').val();
        const $subGroupOpt = $select.find("option").filter(function () {
            return $(this).val() === subGroupVal;
        });
        const subGroupLevel = parseInt($subGroupOpt.data("level") || "1");

        // Find all children of this sub-group (level > subGroupLevel)
        const $childLis = [];
        let $next = $subGroupLi.next();
        while ($next.length && !$next.hasClass("multiselect-group")) {
            const nextVal = $next.find('input[type="checkbox"]').val();
            const $nextOpt = $select.find("option").filter(function () {
                return $(this).val() === nextVal;
            });
            const nextLevel = parseInt($nextOpt.data("level") || "1");
            if (nextLevel <= subGroupLevel) break;

            // Only count non-disabled children
            if (!$next.hasClass("disabled")) {
                $childLis.push($next);
            }
            $next = $next.next();
        }

        if ($childLis.length === 0) return;

        // Check if all children are active
        const allChildrenActive = $childLis.every(($li) => $li.hasClass("active"));
        const subGroupSelected = $subGroupOpt.prop("selected");

        if (allChildrenActive && !subGroupSelected) {
            $subGroupOpt.prop("selected", true);
            changed = true;
        } else if (!allChildrenActive && subGroupSelected) {
            // Auto-uncheck sub-group when not all children are selected
            $subGroupOpt.prop("selected", false);
            changed = true;
        }
    });

    if (changed) {
        $select.multiselect("refresh");
    }
}

const renderDropdownMultiselect = () => {
    const updateSelectCount = ($select) => {
        requestAnimationFrame(() => {
            const $dropdown = $select.next(".c-multiselect-dropdown");
            const $count = $dropdown.find(".multiselect-count");
            const $button = $dropdown.find(".multiselect");

            const selectedCount = $select.find("option:selected").length;

            if (selectedCount > 0) {
                $count.text(`${selectedCount}`);
                $button.addClass("has-selection");
            } else {
                $count.text("");
                $button.removeClass("has-selection");
            }
        });
    };

    $(".js-dropdown-multiselect")
        .not(".is-loaded")
        .each(function () {
            const $select = $(this);

            let options = {
                templates: {
                    button: `
                    <button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown">
                        <span class="multiselect-label">
                            <span class="multiselect-label-text"></span>
                            <span class="multiselect-count"></span>
                        </span>
                        <div class="multiselect-selected-text"></div>
                    </button>
                `,
                },
                buttonContainer:
                    '<div class="c-multiselect-dropdown c-form__item c-form__item--select" />',
                buttonClass: "c-form__input",
                enableHTML: true,
                enableCollapsibleOptGroups: true,
                collapseOptGroupsByDefault: true,
                enableClickableOptGroups: true,

                buttonText(selectedOptions, selectElement) {
                    if (selectedOptions.length === 0) {
                        return "";
                    }

                    const chips = [];
                    selectedOptions.each(function () {
                        const $opt = $(this);
                        const label = $opt.text().trim();
                        const value = $opt.val();

                        chips.push(
                            `<span class="c-multiselect-chip" data-value="${value}">${label}</span>`
                        );
                    });

                    return chips.join(", ");
                },

                buttonTitle(selectedOptions, selectElement) {
                    const $selectEl = $(selectElement);
                    const baseLabel =
                        $selectEl.data("selected-text") || $selectEl.data("empty-text") || "";

                    if (selectedOptions.length === 0) {
                        return baseLabel;
                    }

                    const labels = [];
                    selectedOptions.each(function () {
                        labels.push($(this).text().trim());
                    });

                    return `${baseLabel}: ${labels.join(", ")}`;
                },
            };

            if (
                ($select.closest("#filter").length ||
                    $select.closest(".js-recipes-filter").length) &&
                $select.prop("multiple")
            ) {
                options.templates.filter = `
                <div class="multiselect-item multiselect-filter">
                    <div class="c-form__item c-form__item--text">
                        <input class="c-form__input multiselect-search" type="text">
                    </div>
                </div>
            `;
                options.filterPlaceholder = $select.data("filter-text");
                options.enableCaseInsensitiveFiltering = true;
            }

            $select.multiselect(options);
            $select.addClass("is-loaded");
            $select.prop("tabindex", -1);

            $select.multiselect("rebuild");

            addOptgroupCarets($select);
            processSubGroups($select);

            const labelText = $select.data("selected-text") || $select.data("empty-text") || "";

            const $dropdown = $select.next(".c-multiselect-dropdown");

            // Remove href from optgroup headers to hide "javascript:void(0);" in browser status bar
            setTimeout(() => {
                $dropdown.find("li.multiselect-group a[href]").removeAttr("href");
            }, 0);
            $dropdown.find(".multiselect-label-text").text(labelText);

            $dropdown.on("click", ".multiselect.dropdown-toggle", () => {
                requestAnimationFrame(() => addOptgroupCarets($select));
            });

            updateSelectCount($select);

            $select.on("change", function () {
                updateSelectCount($select);

                $select.multiselect("refresh");

                requestAnimationFrame(() => {
                    addOptgroupCarets($select);

                    const bubblesItems = document.querySelectorAll(".filter-bubbles__item");

                    if (bubblesItems) {
                        bubblesItems.forEach((bubblesItem) => {
                            bubblesItem.addEventListener("click", () => {
                                updateSelectCount($select);

                                $select.multiselect("refresh");
                            });
                        });
                    }

                    // Auto-check sub-groups when all their children are selected
                    syncSubgroupCheckboxes($select);
                    // Auto-check main optgroup when all its sub-groups are selected
                    syncOptgroupCheckboxes($select);
                });
            });

            // Sync counts and bubbles on mobile when reset button is clicked
            const $form = $select.closest("form");
            if ($form.length) {
                const $resetButton = $form.find('button[type="reset"], input[type="reset"]');

                if ($resetButton.length) {
                    $resetButton.on("click", () => {
                        requestAnimationFrame(() => {
                            updateSelectCount($select);
                            $select.multiselect("refresh");
                            addOptgroupCarets($select);
                            updateActivePropertyCheckboxes();
                        });
                    });
                }
            }
        });

    requestAnimationFrame(() => {
        addMultiselectCustomData($(".js-dropdown-multiselect"));
    });
};

const renderMultiselect = () => {
    $("#filter select")
        .not(".is-loaded")
        .each(function () {
            const $select = $(this);
            let options = {
                templates: {
                    button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><span class="multiselect-selected-text"></span><i class="ico ico-triangle-down is-on-right"></i></button>',
                },
                buttonClass: "c-btn has-icon",
                enableHTML: true,
                enableCollapsibleOptGroups: true,
                collapseOptGroupsByDefault: true,
                enableClickableOptGroups: true,
            };

            if (
                $select.closest("#filter").length ||
                ($select.closest(".js-recipes-filter").length && $select.prop("multiple"))
            ) {
                const moreText = $select.data("more-text");
                const lessText = $select.data("less-text");

                options.templates.ul = `
                <r-more-items r-more-items-self-target class="multiselect-container dropdown-menu" data-more-text="${moreText}" data-less-text="${lessText}">
                    <button type="button" class="c-link is-underlined is-uppercase is-more has-icon" r-more-items-trigger>
                        <span r-more-items-trigger-text>${moreText}</span>
                        <i class="ico ico-caret-down-thick is-on-right"></i>
                    </button>
                </r-more-items>
            `;
                options.templates.filter = `
                <div class="multiselect-item multiselect-filter">
                    <div class="c-form__item c-form__item--text">
                        <input class="c-form__input multiselect-search" type="text">
                    </div>
                </div>
            `;
                options.filterPlaceholder = $select.data("filter-text");
                options.enableCaseInsensitiveFiltering = true;
                options.onFiltering = (input) => {
                    const $input = $(input);
                    const $dropdownMenu = $input.closest(".dropdown-menu");

                    if ($input.val()) {
                        $dropdownMenu.addClass("is-filtering");
                    }
                    if (!$input.val()) {
                        $dropdownMenu.removeClass("is-filtering");

                        $dropdownMenu.find("li").each(function () {
                            $(this).css("display", "");
                        });
                    }
                };
            }

            $select.multiselect(options);
            $select.addClass("is-loaded");
        });

    requestAnimationFrame(() => {
        addMultiselectCustomData($("#filter").find('select[type="multiselect"]'));
        addFilterAndMore($("#filter").find('select[type="multiselect"]'));
    });
};

function addOptgroupCarets($select) {
    const $dropdown = $select.next(".c-multiselect-dropdown");

    // len optgroup caret kontajnery (bezpečnejšie)
    const $carets = $dropdown.find("li.multiselect-group .caret-container");

    if (!$carets.length) return; // ešte to nie je vyrenderované

    $carets.html('<i class="ico ico-chevron-down"></i>');
}

export function processSubGroups($select) {
    const $container = $select.next().find("ul.multiselect-container");

    $container.find("li.multiselect-group").each(function () {
        const $groupLi = $(this);
        const $groupItems = $groupLi.nextUntil("li.multiselect-group");

        $groupItems.each(function () {
            const $li = $(this);
            if ($li.hasClass("multiselect-sub-group")) return;

            const $input = $li.find('input[type="checkbox"]');
            const val = $input.val();
            const $option = $select.find("option").filter(function () {
                return $(this).val() === val;
            });
            const rawLevel = $option.data("level");
            const level = rawLevel !== undefined ? parseInt(rawLevel) : 1;
            const hasChildren = $option.data("hasChildren") === true;

            if (level > 1) {
                $li.addClass(`is-level-${level}`);
            } else if (level === 0) {
                $li.addClass("is-level-0");
            }

            if (hasChildren) {
                $li.addClass("multiselect-sub-group");
                const $a = $li.find("a");
                if (!$a.find(".sub-caret-container").length) {
                    $a.append(
                        '<span class="sub-caret-container caret-container"><i class="ico ico-chevron-down"></i></span>'
                    );
                }

                // Hide children initially
                let $next = $li.next();
                while ($next.length && !$next.hasClass("multiselect-group")) {
                    const nextVal = $next.find('input[type="checkbox"]').val();
                    const $nextOpt = $select.find("option").filter(function () {
                        return $(this).val() === nextVal;
                    });
                    const nextLevel = parseInt($nextOpt.data("level") || "1");
                    if (nextLevel <= level) break;
                    $next.addClass("js-sub-hidden").hide();
                    $next = $next.next();
                }

                // Sub-group caret click: toggle children
                $a.find(".sub-caret-container")
                    .off("click.subgroup")
                    .on("click.subgroup", function (e) {
                        e.stopPropagation();
                        const opening = !$li.hasClass("is-sub-open");
                        $li.toggleClass("is-sub-open", opening);
                        $(this).find("i").toggleClass("ico-chevron-down ico-chevron-up");

                        let $next = $li.next();
                        while ($next.length && !$next.hasClass("multiselect-group")) {
                            const nextVal = $next.find('input[type="checkbox"]').val();
                            const $nextOpt = $select.find("option").filter(function () {
                                return $(this).val() === nextVal;
                            });
                            const nextLevel = parseInt($nextOpt.data("level") || "1");
                            if (nextLevel <= level) break;
                            if (opening) {
                                $next.removeClass("js-sub-hidden").show();
                            } else {
                                $next.addClass("js-sub-hidden").hide();
                            }
                            $next = $next.next();
                        }
                    });

                // Sub-group checkbox change: cascade to children (both check and uncheck)
                $input.off("change.subgroupCascade").on("change.subgroupCascade", function () {
                    const isChecked = $(this).is(":checked");

                    let $next = $li.next();
                    while ($next.length && !$next.hasClass("multiselect-group")) {
                        const nextVal = $next.find('input[type="checkbox"]').val();
                        const $nextOpt = $select.find("option").filter(function () {
                            return $(this).val() === nextVal;
                        });
                        const nextLevel = parseInt($nextOpt.data("level") || "1");
                        if (nextLevel <= level) break;

                        if (!$next.hasClass("disabled")) {
                            $next.find('input[type="checkbox"]').prop("checked", isChecked);
                            $nextOpt.prop("selected", isChecked);
                            $next.toggleClass("active", isChecked);
                        }
                        $next = $next.next();
                    }
                });
            }
        });

        // After top-level optgroup expand, re-hide any still-collapsed sub-group children
        $groupLi
            .find(".caret-container:not(.sub-caret-container)")
            .off("click.subfix")
            .on("click.subfix", function () {
                requestAnimationFrame(() => {
                    $container.find(".js-sub-hidden").hide();
                });
            });
    });
}

const addMultiselectCustomData = ($selects) => {
    $selects.each(function () {
        const $select = $(this),
            $options = $select.find("option"),
            $dropdownMenu = $select.next().find(".dropdown-menu"),
            type = $select.data("type");

        $options.each(function () {
            const $option = $(this),
                count = $option.data("count"),
                transliterate = $option.data("transliterate"),
                value = $option.val(),
                $fakeInput = $dropdownMenu.find('input[value="' + value + '"]'),
                $fakeInputLabel = $fakeInput.parent();

            // kvoli vyhladavaniu, aby diaktiritka bola irelevantna
            if (transliterate && !$fakeInputLabel.find(".c-transliterate").length) {
                $fakeInputLabel.append(
                    `<span class="hidden c-transliterate">${transliterate}</span>`
                );
            }

            // Only append count HTML on initial load (when count element doesn't exist yet)
            if (count && !$fakeInputLabel.find(".is-count.filter__content__count").length) {
                $fakeInputLabel.append(count);

                // Set data attributes so Filter.refreshCounts() can update this element
                $fakeInput
                    .parents("a")
                    .attr("data-element", "filterItem")
                    .attr("data-type", type)
                    .attr("data-field-value", value)
                    .attr("data-count", count.replace(/<[^>]*>?/gm, "").replace(/[()]/g, ""));
            }
        });
    });
};

const addFilterAndMore = ($selects) => {
    $selects.each(function () {
        const $dropdownMenu = $(this).next().find(".dropdown-menu");
        const $options = $dropdownMenu.find("li");

        if ($options.length > 6) {
            $dropdownMenu.addClass("hide-items");
            $options.each(function (key, item) {
                if (key > 3) {
                    $(this).addClass("is-hidden");
                }
            });
        }
    });
};

function updateRangeCallback(selectors, values, sliderInstance) {
    const $from = $(selectors.from),
        $to = $(selectors.to),
        fromVal = parseInt($from.val()),
        toVal = parseInt($to.val()),
        minValue = parseInt(sliderInstance.options.range.min[0]),
        maxValue = parseInt(sliderInstance.options.range.max[0]),
        valueFrom = parseInt(values[0]),
        valueTo = parseInt(values[1]);

    // if (minValue == valueFrom && maxValue == valueTo) {
    //     $from.val('').removeAttr('value');
    //     $to.val('').removeAttr('value');

    //     Filter.submit();

    //     return true;
    // }

    $from.val(values[0]);
    $to.val(values[1]);

    // if (!fromVal && !toVal) {
    //     $to.trigger('change');
    // }
    // else if (fromVal === valueFrom) {
    //     $to.trigger('change');
    // }
    // else if (toVal === valueTo) {
    //     $from.trigger('change');
    // }

    Filter.submit();
}

function createPriceRange() {
    const $elem = $(".js-range-price"),
        $slider = $elem.find(".range-slider__slider"),
        maxValue = parseInt($elem.attr("data-max")),
        minValue = parseInt($elem.attr("data-min")),
        fromValue = parseInt($elem.attr("data-from")),
        toValue = parseInt($elem.attr("data-to")),
        currencySymbol = Eshop.options.currency.symbol_right,
        wNumbOptions = {
            decimals: 0,
            suffix: ` ${currencySymbol}`,
        };

    if (!$slider.length) {
        return false;
    }

    $rangeSlider = noUiSlider.create($slider[0], {
        start: [fromValue, toValue],
        range: {
            min: [minValue],
            max: [maxValue],
        },
        margin: 1,
        connect: true,
        tooltips: [wNumb(wNumbOptions), wNumb(wNumbOptions)],
        format: wNumb(wNumbOptions),
        step: 1,
    });

    $rangeSlider.on("change", function (values, handle) {
        updateRangeCallback(
            {
                from: '[name="filter[price][from]"]',
                to: '[name="filter[price][to]"]',
            },
            values,
            this
        );

        $(".js-filter-price-range:checked").prop("checked", false);
    });

    $("#filter-price-from, #filter-price-to").on("keydown", function (event) {
        if (event.which == 13 || event.keyCode == 13) {
            event.preventDefault();

            $(this).blur();
            $(this).trigger("change");
        }
    });

    $("#filter-price-from, #filter-price-to").on("focus", function (event) {
        $(this).val(parseInt($(this).val()));
    });

    $("#filter-price-from, #filter-price-to").on("blur", function (event) {
        const isFrom = this.name === "filter[price][to]";

        let value = parseInt($(this).val());

        if (isNaN(value)) {
            value = parseInt($(this).prop(isFrom ? "min" : "max"));
        }

        $(this).val(wNumb(wNumbOptions).to(parseInt($(this).val())));
    });

    $("#filter-price-from").on("change", function (event) {
        event.preventDefault();

        const min = parseInt($(this).attr("min"));
        const inputToValue = parseInt($("#filter-price-to").val());
        let value = parseInt($(this).val());
        let setInput = false;

        if (value < min) {
            value = min;
            setInput = true;
        } else if (value > inputToValue) {
            value = inputToValue;
            setInput = true;
        }

        if (setInput) {
            $(this).val(value);
        }

        $rangeSlider.set([value, null]);
    });

    $("#filter-price-to").on("change", function (event) {
        event.preventDefault();

        const max = parseInt($(this).attr("max"));
        const inputFromValue = parseInt($("#filter-price-from").val());
        let value = parseInt($(this).val());
        let setInput = false;

        if (value > max) {
            value = max;
            setInput = true;
        } else if (value < inputFromValue) {
            value = inputFromValue;
            setInput = true;
        }

        if (setInput) {
            $(this).val(value);
        }

        $rangeSlider.set([null, value]);
    });
}

const changeFakeSortButton = (value) => {
    $fakeSortButtons.find(".c-btn").removeClass("is-active");
    $fakeSortButtons.find(`.c-btn[data-value="${value}"]`).addClass("is-active");
};

rEvent.on("Listing.fetchedData", function (data) {
    const $listingCount = $(".js-listing-count");

    if ($listingCount.length) {
        $listingCount.each(function () {
            const $countElem = $(this);
            let countHtml = data.count;

            if ($countElem.hasAttr("data-plural")) {
                const listingPlural = $countElem.data("plural");

                countHtml =
                    data.count +
                    " " +
                    Format.plural(listingPlural[0], listingPlural[1], listingPlural[2], data.count);
            }

            if ($countElem.hasAttr("data-template")) {
                countHtml = $countElem.data("template").replace(":value:", countHtml);
            }

            $countElem.html(countHtml);
        });
    }
});

Filter.submit = function () {
    rEvent.dispatch("Filter.beforeSubmit");

    for (const sliderEl of this.element.querySelectorAll(".js-filter-slider-holder")) {
        const inputs = sliderEl.querySelectorAll("input");
        let isBoundary = true;

        boundaryCheck: for (const input of inputs) {
            for (const attribute of ["min", "max"]) {
                if (
                    input.hasAttribute(attribute) &&
                    parseFloat(input.getAttribute(attribute)) != parseFloat(input.value)
                ) {
                    isBoundary = false;

                    break boundaryCheck;
                }
            }
        }

        if (isBoundary) {
            for (const input of inputs) {
                input.value = "";
            }
        }
    }

    Listing.sendData(this.element, (response) => {
        this.submitCallback(response);
    });

    return false;
};

$(function () {
    // renderMultiselect();
    renderDropdownMultiselect();

    if ($(".filter-price").length > 0) {
        createPriceRange();
    }

    // fake sort
    const sortValue = $sort.val();

    if (sortValue) {
        $fakeSort.val(sortValue);
        changeFakeSortButton(sortValue);
    }

    $fakeSort.on("change", function () {
        const value = $(this).val();

        $sort.val(value).trigger("change");
    });

    $fakeSortButtons.on("click", ".c-btn", function () {
        const value = $(this).data("value");

        changeFakeSortButton(value);
        $sort.val(value).trigger("change");
    });

    // fake bought
    $fakeBought.on("change", function () {
        const isChecked = $(this).is(":checked");

        $bought.val(isChecked ? 1 : 0);
        $bought.prop("checked", true).trigger("change");
    });

    // fake limit
    $(".l-content").on("change", ".js-paginator-limit", function () {
        const value = $(".js-paginator-limit").val();

        $("#limit").val(value);

        Filter.submit();
    });

    // fake view
    let viewValue = getCookie("listingView");

    if (viewValue) {
        $(".js-fake-view#" + viewValue).addClass("is-active");
    } else {
        $(".js-fake-view#grid").addClass("is-active");
    }

    $fakeView.on("click", function () {
        viewValue = $(this).data("value");

        $view.val(viewValue).change();
    });

    rEvent.on("Listing.changeView", function () {
        const $view = $("#filter-view"),
            value = $view.val();

        $(".js-fake-view").removeClass("is-active");
        $(".js-fake-view#" + value).addClass("is-active");

        $(".products").removeClass("products--row").removeClass("products--grid");
        $(".products").addClass("products--" + value);

        $(".products .js-thumb").removeClass("is-row").removeClass("is-grid");
        $(".products .js-thumb").addClass("is-" + value);
    });

    // filter reset
    rEvent.on("Filter.reset", function () {
        const $inputFrom = $("#filter-price-from"),
            fromValue = parseInt($inputFrom.attr("min")),
            $inputTo = $("#filter-price-to"),
            toValue = parseInt($inputTo.attr("max"));

        $inputFrom.val(fromValue);
        $inputTo.val(toValue);

        if ($rangeSlider) {
            $rangeSlider.set([fromValue, toValue]);
        }

        $(".js-filter-price-range:checked").prop("checked", false);

        $('[name="filter[rating_avg]"]').each(function () {
            // if ($(this).val() == '0_100') {
            //     $(this).prop('checked', true).change();
            // } else {
            $(this).prop("checked", false).change();
            // }
        });
    });

    $(".js-filter-price-range").on("change", function () {
        const $checkedInput = $(".js-filter-price-range:checked"),
            priceArray = $checkedInput.val().split(";"),
            actualMin = parseFloat(priceArray[0]),
            actualMax = parseFloat(priceArray[1]);

        let min = 99999,
            max = 0;

        if (actualMin < min) {
            min = actualMin;
        }

        if (actualMax > max) {
            max = actualMax;
        }

        $("#filter-price-from").val(min);
        $("#filter-price-to").val(max);

        $rangeSlider.set([min, max]);

        Filter.submit();
    });
});

rEvent.on("Listing.fetchedData", function (data) {
    initTippy();
    const $listingCount = $(".js-listing-count");

    if ($listingCount.length) {
        $listingCount.each(function () {
            const $countElem = $(this);
            let countHtml = data.count;
            const isCountDesktop = $countElem.data("listing-count") === "desktop";

            countHtml = `
                    <span class="sc-text">${data.count}</span>
                    ${Format.plural(
                        listingProductsLocale.single,
                        listingProductsLocale.twoToFour,
                        listingProductsLocale.plural,
                        data.count
                    )}`;

            if ($countElem.hasAttr("data-template")) {
                countHtml = $countElem.data("template").replace(":value:", countHtml);
            }

            $countElem.html(countHtml);
        });
    }
});

// Update multiselect data-count attributes after filter changes
rEvent.on("Listing.fetchedData", function () {
    $(".js-dropdown-multiselect").each(function () {
        const $select = $(this);
        const $dropdownMenu = $select.next().find(".dropdown-menu");

        // Update data-count attribute on each link based on the updated r-span value
        $dropdownMenu.find('a[data-element="filterItem"]').each(function () {
            const $link = $(this);
            const $aggregationSpan = $link.find('[data-element="filterItemAggregation"]');

            if ($aggregationSpan.length) {
                const currentCount = $aggregationSpan.text().trim();
                $link.attr("data-count", currentCount);
            }
        });
    });
});

// Remove href from optgroup headers on hover to hide "javascript:void(0);" in browser status bar
$(document).on("mouseenter", "li.multiselect-group > a", function () {
    $(this).removeAttr("href");
});
